import React from 'react';
import { colors } from './theme';
import { analyticsCardStyles as card } from './analytics/analyticsCardStyles';

export default function DeviceAnalyticsCard({ stats }) {
  if (!stats) return null;
  const assignmentMap = {
    'in field': colors.accent,
    decommissioned: colors.danger,
    'trade fairs': colors.statusYellow,
    'customer testing': colors.success,
  };

  const assignments = stats.assignmentCounts;

  return (
    <div style={{ ...card.shell, maxWidth: '720px' }}>
      <div style={card.header}>
        <div style={card.titleWrap}>
          <p style={card.eyebrow}>Fleet state</p>
          <h2 style={card.title}>Device Analytics</h2>
        </div>
      </div>
      <div style={card.body}>
        <section style={{ ...card.section, marginBottom: '1rem' }}>
          <h4 style={card.sectionTitle}>Assignments</h4>
          <ul style={card.list}>
            {assignments.map(item => {
              const label = item._id || 'in field';
              const color = assignmentMap[item._id || 'in field'] || colors.muted;
              return (
                <li key={item._id} style={card.listRow}>
                  <span style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: colors.textBody }}>
                    <span style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: color, display: 'inline-block' }}></span>
                    {label}
                  </span>
                  <strong style={card.statValue}>{item.count}</strong>
                </li>
              );
            })}
          </ul>
        </section>
        <section style={card.section}>
          <h4 style={card.sectionTitle}>Warranty Status</h4>
          <ul style={card.list}>
            <li style={card.listRow}>
              <span style={{ color: colors.textBody }}>Within warranty</span>
              <span style={{ display: 'flex', gap: '0.25rem', alignItems: 'center' }}>
                <strong style={card.statValue}>{stats.warranty.within}</strong>
                <span style={{ color: colors.statusYellow }}>
                  ({stats.warranty.warning})
                </span>
              </span>
            </li>
            <li style={card.listRow}>
              <span style={{ color: colors.textBody }}>Outside warranty</span>
              <strong style={card.statValue}>{stats.warranty.outside}</strong>
            </li>
          </ul>
        </section>
      </div>
    </div>
  );
}
